<template>
  <div class="fblogin-container">
    <div v-if="logged == 'cancelled'">
  		<slot name="cancelled">
  		</slot>
  		<button
  			@click = "login"
  			type   = "button"
  			class  = "btn btn-primary">
  			Facebook Login
  		</button>
  	</div>
  	<div v-else-if="logged == 'not_logged'">
  		<slot name="check-login">
  			connecting with facebook...
  		</slot>
  	</div>
  	<div v-else-if="logged == 'logged'">
  		<slot name="logged">
        already logged in...
  		</slot>
    </div>
    <!-- do not put this within v-if v-else -->
    <div
      id="fb-send-to-messenger"
      class="fb-send-to-messenger"
      messenger_app_id="782732588553167"
      page_id="418381418548219"
      data-ref="PASS_THROUGH_PARAM"
      color="white"
      size="standard"
      style="display:inherit;">
      subscribe chat bot
    </div>
    <div class="fb-like" data-href="https://noctorus.studio/" data-layout="button" data-action="like" data-size="large" data-show-faces="true" data-share="false">
      like button
    </div>
	</div>
</template>

<script>
  import FBControl from '@/controllers/FBControl'
  export default {
    data: function () {
      return {
        logged: 'not_logged',
        FB: undefined
      }
    },
    props: {
    },
    created () {
      FBControl.getFB()
      .then((FB) => {
        console.log('getting FB@!!')
        console.log(FB)
        this.FB = FB
        this.FB.login(this.check_login)
      })
      .catch((error) => {
        console.log('no FB@!!')
        console.log(error)
      })
    },
    methods: {
      cancelled: function (response) {
        console.log('fb: cancelled')
        // FB.login(this.check_login);
        this.logged = 'cancelled'
      },
      logged_in: function (response) {
        console.log('fb: logged_in')
        this.logged = 'logged'
        this.$emit('fb-logged')
        console.log(response)
        // var token = 'EAALH5CHlE88BAHZA8bGBD0uaTrsZA4CAkEiQQ7eLXlyxdWpgFBAgbRTYcwwEdTaZC7EYKm4TZBI549Pq4IKlFmZCZAtamgZBZAZCrv0XQ4Ohl7EgJs5rv8eaLbrpFF1zH4GAQe6ZCaLuefOWTwV0D1IWElcWpv9sAd9kU7I1PzY54vXQZDZD'
        // this.FB.api('/me/messages?access_token=' + token, {
        //   receipient: {
        //     id: '418381418548219'
        //   },
        //   message: {
        //     text: 'hello123'
        //   }
        // }, function (response) {
        //   console.log('fb: message success')
        //   console.log(response)
        // }, function (error) {
        //   console.log('fb: message error')
        //   console.log(error)
        // })
      },
      login: function () {
        console.log('fb: login')
        this.FB.login(this.check_login)
      },
      check_login: function (response) {
        if (response.status === 'connected') {
          console.log('fb: check_login: connected')
          this.logged_in(response)
        } else {
          console.log('fb: check_login: not connected, retry')
          this.FB.login((response) => {
            if (response.status === 'connected') {
              this.logged_in(response)
              return
            }
            this.cancelled(response)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FBLogin.vue?188ea2ca